import React from 'react';
import ScriptGuideTemplate from '../../components/Templates/ScriptGuideTemplate';

const ScriptGuide = () => {
  return <ScriptGuideTemplate />;
};

export default ScriptGuide;
